import {BehaviorSubject} from 'rxjs';
import {mc} from '@/core';
import {premiumApi} from '@/api';
import {browser$} from '@/streams/browser';
import {afterLogin$} from '@/streams/auth';

export const supportCurrencies$ = new BehaviorSubject([]);
export const userTasks$ = new BehaviorSubject({
  status: 100,
  taskList: [],
});
export const purchasePlans$ = new BehaviorSubject([{membershipType: 'purchasePlan30V1', currencyName: 'USDT', price: '9.9', originPrice: '', days: 30}]);

browser$.subscribe(() => {
  loadPurchasePlans();
  loadSupportCurrency();
});

afterLogin$.subscribe(() => loadUserTask());

async function loadUserTask() {
  const {data, error} = await premiumApi.getUserTasks();
  if (data) {
    userTasks$.next(data);
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
}

async function loadPurchasePlans() {
  const {data} = await premiumApi.getPurchasePlans();
  if (data) {
    purchasePlans$.next(data);
  }
}
async function loadSupportCurrency() {
  const {data} = await premiumApi.getSupportCurrency();
  if (data) {
    supportCurrencies$.next(data.supportCurrencyList);
  }
}
